import styled from "styled-components";
const ModalBody = styled("div")(
  {
    boxSizing: "border-box",
    padding: 16
  },
  ({ spacing }) => ({
    none: {
      padding: 0
    }
  })[spacing]
);
export {
  ModalBody
};
